import { FilterChip } from "../FilterChip";
import { FilterRange } from "./types";
import { buildRangeLabel } from "./utils";
import { RangeFilter } from "./RangeFilter";
import { useRangeFilter } from "./hooks/useRangeFilter";

interface EmployeesRangeFilterChipProps {
  range: FilterRange;
  handleRangeChange: (min: number | undefined, max: number | undefined) => void;
  highlighted?: boolean;
  id?: string;
}

export const EmployeesRangeFilterChip = ({
  range,
  handleRangeChange: onChange,
  highlighted,
  id = "employees-range",
}: EmployeesRangeFilterChipProps) => {
  const { range: employeeRange, handleRangeChange } = useRangeFilter({
    initialRange: range,
    hasFixedValue: false,
    onRangeChange: (newRange) => onChange(newRange.min, newRange.max),
  });

  return (
    <FilterChip
      id={id}
      label="Employees Range"
      getSelectedCount={() => 0}
      renderLabel={() => buildRangeLabel(range)}
      popoverOptions={{ disableActionButtons: true }}
      onDelete={() => {
        onChange(undefined, undefined);
      }}
      addTitleClearButton={true}
      highlighted={highlighted}
    >
      <RangeFilter
        updatedOnType={true}
        value={employeeRange}
        onChange={(min, max) => handleRangeChange({ min, max })}
      />
    </FilterChip>
  );
};
